module.exports = __webpack_public_path__ + "img/BC_Logo_Colour.png";